import React, { useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { tokenIsValid } from 'src/auth';
import { authContext } from 'src/contexts/AuthContext';
import TopNavigation from 'src/components/TopNavigation';

const PrivateRoute: React.FC<RouteProps> = (props) => {
  const auth = useContext(authContext);
  if (tokenIsValid(auth.authToken)) {
    return (
      <>
        <TopNavigation />
        <Route {...props} />
      </>
    );
  }
  return <Redirect to="/signin" />;
};

export default PrivateRoute;
